import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {Button} from "@unibuddy/patron";

export interface ChatNowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    name: string;
    onChatNow: () => void;
    large?: boolean;
    id?: string;
    className?: string;
}

export const ChatNowButton: React.FC<ChatNowButtonProps> = ({
    id = "",
    className,
    large = false,
    onChatNow,
    name,
    ...props
}) => {
    const {t} = useTranslation("mentorCard");

    return (
        <Button
            id={id}
            className={className}
            onClick={onChatNow}
            size={large ? "lg" : "md"}
            round
            ghost
            color="university"
            {...props}
        >
            {t("chatWith", `Chat with ${name}`, {name})}
        </Button>
    );
};

